import { alpha, Box, Typography } from '@mui/material';
import React, { useEffect } from 'react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

// import required modules
import { Helmet } from 'react-helmet-async';
import { Trans, useTranslation } from 'react-i18next';
import AnimatedTypography from '../../core/AnimatedTypography';
import Container from '../../../layout/Container';
import CateringGallery from '../components/CateringGallery';

interface AboutUsPageProps {
}

const AboutUsPage: React.FC<AboutUsPageProps> = ({ }) => {
    const { t } = useTranslation();

    useEffect(() => {
        window?.scrollTo({ top: 0, behavior: "smooth" })
    }, [])

    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>{t("seo.aboutUs.title")}</title>
                <meta name="description" content={t("seo.aboutUs.description")} />
                <link rel="canonical" href="https://enduro-connection-radusa.com/about-us/" />
                <meta property="og:title" content={t("seo.aboutUs.title")} />
                <meta property="og:description" content={t("seo.aboutUs.ogDescription")} />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://enduro-connection-radusa.com/about-us/" />
            </Helmet>

            <Box mt={{ xs: 8, sm: 10 }}>
                <Container>
                    <AnimatedTypography variant='h3' color={"text2.primary"} fontWeight={700} mb={2}>
                        {t("abousUs.title")}
                    </AnimatedTypography>
                    <Box
                        sx={{
                            mt: { xs: 4, md: 6 },
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr", md: "1fr" },
                            gap: { xs: 3, md: 4 },
                        }}
                    >
                        <Box
                            sx={(theme) => ({
                                p: { xs: 3, md: 4 },
                                borderRadius: 3,
                                backgroundColor: alpha(theme.palette.background.paper, 0.7),
                                backdropFilter: "blur(16px)",
                                border: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
                                boxShadow: `0 24px 60px ${alpha(theme.palette.common.black, 0.1)}`,
                                ...theme.applyStyles("dark", {
                                    backgroundColor: alpha(theme.palette.background.paper, 0.4),
                                    boxShadow: `0 24px 60px ${alpha(theme.palette.common.black, 0.4)}`,
                                })
                            })}
                        >
                            <Typography variant="h5" fontWeight={700} color="text.primary" mb={1.5}>
                                {t("abousUs.section2.title")}
                            </Typography>
                            <Typography color="text2.primary">
                                {t("abousUs.section2.1")}
                            </Typography>
                        </Box>

                    </Box>

                    <Box
                        sx={{
                            mt: { xs: 3, md: 4 },
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
                            gap: { xs: 3, md: 4 },
                            alignItems: "start",
                        }}
                    >
                        <Box
                            sx={(theme) => ({
                                p: { xs: 3, md: 4 },
                                borderRadius: 3,
                                backgroundColor: alpha(theme.palette.background.paper, 0.7),
                                backdropFilter: "blur(16px)",
                                border: `1px solid ${alpha(theme.palette.divider, 0.2)}`,
                                boxShadow: `0 24px 60px ${alpha(theme.palette.common.black, 0.1)}`,
                                ...theme.applyStyles("dark", {
                                    backgroundColor: alpha(theme.palette.background.paper, 0.4),
                                    boxShadow: `0 24px 60px ${alpha(theme.palette.common.black, 0.4)}`,
                                })
                            })}
                        >
                            <Typography variant="h5" fontWeight={700} color="text.primary" mb={1.5}>
                                {t("abousUs.section4.title")}
                            </Typography>
                            <Typography color="text2.primary" mb={2}>
                                {t("abousUs.section4.1")}
                            </Typography>
                            <Typography color="text2.primary" mb={2}>
                                {t("abousUs.section4.2")}
                            </Typography>
                            <Typography color="text2.primary" mb={2}>
                                {t("abousUs.section4.3")}
                            </Typography>
                            <Typography color="primary.main" fontWeight={600}>
                                {t("abousUs.section4.4")}
                            </Typography>
                        </Box>

                        <CateringGallery />
                    </Box>
                </Container>
            </Box>
        </>
    )
}

export default AboutUsPage;